export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14655.75c6b8e8.jpg";